import { type ReactNode, useEffect } from 'react';

import { useNavigate, useSearchParams } from 'react-router-dom';

import { LoaderFull } from '@/components';
import { useSecurityTokens } from '@/features/auth';

export const GuardPublicOnly = ({ children }: { children: ReactNode }) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [token] = useSecurityTokens();

  useEffect(() => {
    if (token) {
      const redirect = searchParams?.get('redirect') ?? '/';
      navigate(redirect, {
        replace: true,
      });
    }
  }, [searchParams, navigate, token]);

  if (!token) {
    return <>{children}</>;
  }

  return <LoaderFull />;
};
